import { render, staticRenderFns } from "./AuthorsCard.vue?vue&type=template&id=532a10f2&scoped=true"
import script from "./AuthorsCard.vue?vue&type=script&lang=js"
export * from "./AuthorsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a10f2",
  null
  
)

export default component.exports